import i18n from '@/utils/i18n';
import React from 'react';
import { BaseActionSheet } from '@/components/base-action-sheet';
import { Button } from '@/components/button';
import { createStyles } from '@/contexts/theme-context';
import { FONTS, SCREEN_PADDING, TYPOGRAPHY } from '@/styles';
import { OrderGuidePartitionList } from '@/components/order-guide-partition-list';
import { Text, useWindowDimensions, View } from 'react-native';
import { useLayoutContext } from '@/contexts/layout-context';

interface Props {
  onClose: () => void;
  variantPackUUID: string;
}

const SHEET_HORIZONTAL_PADDING = 16;

export const OrderGuidePartitionSectionActionSheet: React.FC<Props> = ({
  onClose,
  variantPackUUID,
}) => {
  const { height } = useWindowDimensions();

  const { isSmallLayout } = useLayoutContext();
  const [styles] = useStyles();

  return (
    <BaseActionSheet
      contentStyle={[
        styles.content,
        isSmallLayout ? styles.contentSmall : null,
        {
          maxHeight: height * 0.85,
        },
      ]}
      isVisible
      modalCloseButtonProps={{
        children: i18n.t('done'),
      }}
      onClose={onClose}
      title={i18n.t('manage_order_guide_item')}
    >
      {isSmallLayout ? (
        <View style={styles.smallLayoutHeader}>
          <View style={styles.smallLayoutHeaderSide} />
          <View style={styles.smallLayoutHeaderCenter}>
            <Text
              numberOfLines={1}
              style={[TYPOGRAPHY.large, FONTS.primaryBold]}
            >
              {i18n.t('manage_order_guide_item')}
            </Text>
          </View>
          <View style={styles.smallLayoutHeaderSide}>
            <Button
              onPress={onClose}
              size="xsmall"
              style={styles.smallLayoutDoneButton}
              textStyle={[TYPOGRAPHY.large, FONTS.primaryBold]}
              trackingData={{
                name: 'order_guide_partition_selector.done_button',
              }}
              type="tertiary"
            >
              {i18n.t('done')}
            </Button>
          </View>
        </View>
      ) : null}
      <OrderGuidePartitionList variantPackUUID={variantPackUUID} />
    </BaseActionSheet>
  );
};

const useStyles = createStyles(() => ({
  content: {
    paddingBottom: 0,
    paddingHorizontal: 0,
  },
  contentSmall: {
    paddingTop: SCREEN_PADDING,
  },
  smallLayoutDoneButton: {
    paddingHorizontal: 0,
  },
  smallLayoutHeader: {
    alignItems: 'center',
    flexDirection: 'row',
    marginBottom: 8,
    paddingHorizontal: SHEET_HORIZONTAL_PADDING,
  },
  smallLayoutHeaderCenter: {
    alignItems: 'center',
    flex: 5,
  },
  smallLayoutHeaderSide: {
    alignItems: 'flex-end',
    flex: 1,
  },
}));
